import { useDispatch, useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import { Typography } from "@mui/material";

import { setUnlockDriversWeekModalOpen } from "../../../reducers/ownApp";
import { forceUnlockDriverWeek } from "../../../reducers/driverManagement/thunkActions";
import { unlockDriversWeekModalOpenSelector } from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";
import { UnlockDriversWeekModalActions } from "./UnlockDriversWeekModalActions";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

const UnlockDriversWeekModal = () => {
  const dispatch = useDispatch();

  const classes = useStyles();
  const modalOpen = useSelector(unlockDriversWeekModalOpenSelector);

  const closeClick = () => {
    dispatch(setUnlockDriversWeekModalOpen(false));
  };

  const continueCLick = () => {
    dispatch(setUnlockDriversWeekModalOpen(false));
    dispatch(forceUnlockDriverWeek());
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={modalOpen}
        onClose={closeClick}
        title={`Unlock Drivers Week`}
        content={
          <>
            <Typography className={classes.text}>
              Are you sure you wish to unlock all drivers in the selected depot?
            </Typography>
            <Typography className={classes.text}>
              If you continue, this will remove the locks from all Driver
              records in this depot and these users will lose any unsaved Driver
              changes.
            </Typography>
          </>
        }
        actions={
          <UnlockDriversWeekModalActions
            onCancel={closeClick}
            onContinue={continueCLick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default UnlockDriversWeekModal;
